import { TimeReport } from "../types";

export const removeTimeReportProject = (timeReport: TimeReport, projectGuid: string): TimeReport => {
  return {
    ...timeReport,
    projects: timeReport.projects.filter(p => p.project.guid !== projectGuid),
  };
};
